"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.realmList = void 0;
exports.realmList = [
    {
        person: 1,
        links: [
            {
                account: 'colinwirt.com',
                realms: ['study-rmit'],
                caption: 'RMIT',
                url: 'https://www.rmit.edu.au/',
            },
        ],
        accounts: ['doordash', 'colinwirt.com', 'colin+', 'teamversa.ai'],
        realms: [
            {
                caption: 'doordash',
                account: 'colinwirt.com',
                realm: 'doordash',
                url: 'https://www.doordash.com/',
                links: [
                    { caption: 'DoorDash', url: 'https://www.doordash.com/' },
                    { caption: 'Shared Location', url: 'https://drd.sh/WOa4Z4bgLm7laaZk' },
                    { caption: 'Stats Sheet', url: 'https://docs.google.com/spreadsheets/d/1ezCPE9ErECO8qtX5ZHWt827RBmKG8FErPIegyHOvnaI' },
                ],
            },
            {
                caption: 'audroam',
                account: 'colinwirt.com',
                realm: 'audroam',
            },
            {
                caption: 'my development',
                account: 'colinwirt.com',
                realm: 'my-dev',
            },
            {
                caption: 'RMIT Study',
                account: 'colinwirt.com',
                realm: 'study-rmit',
            },
            {
                caption: 'VERSA AI',
                account: 'teamversa.ai',
                realm: 'versa-ai',
            },
            {
                caption: 'GAM',
                account: 'teamversa.ai',
                realm: 'gam',
            },
            {
                caption: 'my operations',
                account: 'colinwirt.com',
                realm: 'my-ops',
            },
            {
                caption: 'my info',
                account: 'colinwirt.com',
                realm: 'my-info',
            },
            {
                caption: 'tinker',
                account: 'colinwirt.com',
                realm: 'tinker',
            },
            {
                caption: 'my assets',
                account: 'colinwirt.com',
                realm: 'my',
            },
            {
                caption: 'my food',
                account: 'colinwirt.com',
                realm: 'my-food',
            },
            {
                caption: 'our food',
                account: 'colin+',
                realm: 'our-food',
            },
            {
                caption: 'my wardrobe',
                account: 'colinwirt.com',
                realm: 'my-wardrobe',
            },
            {
                caption: 'my travel',
                account: 'colinwirt.com',
                realm: 'travel',
            },
            {
                caption: 'my e',
                account: 'colinwirt.com',
                realm: 'e',
            },
            {
                caption: 'our e',
                account: 'colin+',
                realm: 'e',
                refNumType: 'string',
            },
            {
                caption: 'our home',
                account: 'colin+',
                realm: 'home',
                refNumType: 'string',
            },
            {
                caption: 'my p',
                account: 'colin+',
                realm: 'p',
                refNumType: 'string',
            },
            {
                caption: 'vehicles',
                account: 'colinwirt.com',
                realm: 'v',
            },
            {
                caption: 'our vehicles',
                account: 'colin+',
                realm: 'v',
            },
            {
                caption: 'home',
                account: 'colinwirt.com',
                realm: 'home',
            },
            /*{
                // add http://wrightprint.com.au/
                caption: 'Wright Print',
                account: 'colinwirt.com',
                realm: 'wrightprint',
                url: 'http://wrightprint.com.au/',
                links: [{ caption: 'WP Website', url: 'http://wrightprint.com.au/' }],
            },*/
            {
                caption: 'Monash Bikeshare',
                account: 'monash.edu',
                realm: 'bikeshare',
                slas: [''],
                tasks: [''],
            },
            // {
            //     caption: 'Monash Reuse',
            //     account: 'monash.edu',
            //     realm: 'reuse',
            // },
            // {
            //     caption: 'Monash BPD',
            //     account: 'monash.edu',
            //     realm: 'bpd',
            // },
            {
                caption: 'Monash Permaculture',
                account: 'monash.edu',
                realm: 'MonashPerma',
            },
            {
                caption: 'yuki',
                account: 'leekiri',
                realm: 'yuki',
            },
        ],
    },
    {
        person: 2,
        realms: [
            {
                caption: 'my development',
                account: 'ali',
                realm: 'my-dev',
            },
            {
                caption: 'my assets',
                account: 'ali',
                realm: 'my',
            },
            {
                caption: 'my food',
                account: 'ali',
                realm: 'my-food',
            },
            {
                caption: 'my wardrobe',
                account: 'ali',
                realm: 'my-wardrobe',
            },
            {
                caption: 'vehicles',
                account: 'ali',
                realm: 'v',
            },
            {
                caption: 'home',
                account: 'ali',
                realm: 'home',
            },
            {
                caption: 'Monash Bikeshare',
                account: 'monash.edu',
                realm: 'bikeshare',
                slas: [''],
                tasks: [''],
            },
            {
                caption: 'Monash BPD',
                account: 'monash.edu',
                realm: 'bpd',
            },
            {
                caption: 'Monash Permaculture',
                account: 'monash.edu',
                realm: 'MonashPerma',
            },
        ],
    },
    {
        person: 15,
        realms: [
            {
                caption: 'my development',
                account: 'vlad',
                realm: 'my-dev',
            },
            {
                caption: 'my assets',
                account: 'vlad',
                realm: 'my',
            },
            {
                caption: 'my food',
                account: 'vlad',
                realm: 'my-food',
            },
            {
                caption: 'my wardrobe',
                account: 'vlad',
                realm: 'my-wardrobe',
            },
            {
                caption: 'vehicles',
                account: 'vlad',
                realm: 'v',
            },
            {
                caption: 'home',
                account: 'vlad',
                realm: 'home',
            },
            {
                caption: 'Monash Bikeshare',
                account: 'monash.edu',
                realm: 'bikeshare',
                slas: [''],
                tasks: [''],
            },
            {
                caption: 'Monash BPD',
                account: 'monash.edu',
                realm: 'bpd',
            },
            {
                caption: 'Monash Permaculture',
                account: 'monash.edu',
                realm: 'MonashPerma',
            },
        ],
    },
    {
        person: 12,
        realms: [
            {
                caption: 'a - personal assets',
                account: 'tracey-1',
                realm: 'my',
            },
            {
                caption: 'b - Monash Permaculture',
                account: 'monash.edu',
                realm: 'MonashPerma',
            },
            {
                caption: 'c - Monash Reuse',
                account: 'monash.edu',
                realm: 'reuse',
            },
            {
                caption: 'd - Monash BPD',
                account: 'monash.edu',
                realm: 'bpd',
            },
        ],
    },
    {
        person: 13,
        realms: [
            {
                caption: 'personal assets',
                account: 'sue-1',
                realm: 'my',
            },
            {
                caption: 'Monash Organic',
                account: 'monash.edu',
                realm: 'r-organic',
            },
            {
                caption: 'Monash Permaculture',
                account: 'monash.edu',
                realm: 'MonashPerma',
            },
            {
                caption: 'Monash Reuse',
                account: 'monash.edu',
                realm: 'reuse',
            },
            {
                caption: 'Monash BPD',
                account: 'monash.edu',
                realm: 'bpd',
            },
        ],
    },
    {
        person: 14,
        realms: [
            {
                caption: 'my development',
                account: 'test',
                realm: 'my-dev',
            },
            {
                caption: 'Monash Bikeshare',
                account: 'monash.edu',
                realm: 'bikeshare',
                slas: [''],
                tasks: [''],
            },
        ],
    },
    {
        person: 21,
        realms: [
            {
                caption: 'my dev',
                account: 'leekiri',
                realm: 'my-dev',
            },
            {
                caption: 'yuki',
                account: 'leekiri',
                realm: 'yuki',
            },
            {
                caption: 'monash bootcamp 1',
                account: 'monash.edu',
                realm: 'boot-1',
            },
        ],
    },
    // { person: 0, realms: [] },
];
